import { render, staticRenderFns } from "./CardChatPopup.vue?vue&type=template&id=929402d8&scoped=true&"
import script from "./CardChatPopup.vue?vue&type=script&lang=js&"
export * from "./CardChatPopup.vue?vue&type=script&lang=js&"
import style0 from "./CardChatPopup.vue?vue&type=style&index=0&id=929402d8&prod&lang=css&"
import style1 from "./CardChatPopup.vue?vue&type=style&index=1&id=929402d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929402d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBtn,VCard,VDialog,VForm,VIcon,VList,VListItem,VListItemTitle,VMenu,VProgressCircular,VTextField})
